import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyEngieMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  const bgGradient = (
    <defs>
      <linearGradient id="engieGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: "#00AAFF", stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: "#0070C0", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#E0F7FA", stopOpacity: 1 }} />
      </linearGradient>
    </defs>
  );

  const solarTessellation: JSX.Element[] = [];
  const gridX = 14;
  const gridY = 18;
  const cellSize = 50;
  
  for (let i = 0; i < gridX; i++) {
    for (let j = 0; j < gridY; j++) {
      const x = -350 + i * cellSize;
      const y = -450 + j * cellSize;
      const hexPoints: string[] = [];
      for (let h = 0; h < 6; h++) {
        const angle = (h / 6) * 2 * Math.PI;
        const hx = x + Math.cos(angle) * 22;
        const hy = y + Math.sin(angle) * 22;
        hexPoints.push(`${hx},${hy}`);
      }
      solarTessellation.push(
        <polygon
          key={`hex-${i}-${j}`}
          points={hexPoints.join(" ")}
          fill="none"
          stroke="#00AAFF"
          strokeWidth={1.5}
          opacity={0.2}
        />
      );
    }
  }

  const blueGradientRings: JSX.Element[] = [];
  for (let r = 1; r <= 18; r++) {
    const radius = r * 22;
    blueGradientRings.push(
      <circle
        key={`blue-${r}`}
        cx={0}
        cy={0}
        r={radius}
        fill="none"
        stroke="#FFFFFF"
        strokeWidth={r % 3 === 0 ? 2.5 : 1.5}
        opacity={0.3 - r * 0.012}
      />
    );
  }

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      {bgGradient}
      <rect width={width} height={height} fill="url(#engieGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {solarTessellation}
        {blueGradientRings}
        <circle cx={0} cy={0} r={50} fill="none" stroke="#FFFFFF" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={35} fill="#00AAFF" opacity={0.4} />
      </g>
    </svg>
  );
}
